/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockPositemlinkSuggestionsCtrl
 */
angular.module('mercury.modules.stock.positemlink')
.controller('StockPositemlinkSuggestionsCtrl', ["$filter", "$http", "$scope", "settings", function($filter, $http, $scope, settings) {
  $scope.suggestions = [];

  var loadSuggestions = function(amount) {
    var excludeList = [];
    angular.forEach($scope.suggestions, function(s) {
      excludeList.push(s.posIdentifier);
    });
    var loading = $http.get(settings.apiHost + '/a/StockPositemLinks/Suggestions', {params: {limit: amount, excludePosIdentifiers: excludeList}});
    loading.then(function(response) {

      angular.forEach(response.data, function(suggestion) {
        var posItem = $filter('filter')($scope.posItems, {posIdentifier: suggestion.posIdentifier});

        if (posItem[0]) {
          suggestion.name = posItem[0].name;
          suggestion.priceEx = posItem[0].priceEx;
          $scope.suggestions.push(suggestion);
        }
      });

    });

    return loading;
  };

  $scope.initalLoadPromise.then(function() {
    $scope.suggestionsLoading = loadSuggestions(10);
  });

  $scope.currentPrice = function(suggestion) {
    return suggestion.quantity * suggestion.currentPrice;
  };

  $scope.cogs = function(suggestion) {
    if (suggestion.priceEx === 0) {
      return 0;
    }
    return ($scope.currentPrice(suggestion) / suggestion.priceEx) * 100;
  };

  $scope.commitSuggestion = function(suggestion, index) {
    suggestion.saving = $scope.linkUpdated(suggestion, true);
    suggestion.saving.then(function() {
      $scope.suggestions.splice(index, 1);

      // try load more suggestions.
      loadSuggestions(1);
    });
  };

  $scope.itemSet = function(suggestion, newStockitem) {
    if (!newStockitem) {
      suggestion.recipeId = null;
      suggestion.stockItemId = null;
      suggestion.unitId = null;
      suggestion.unitName = null;
      suggestion.unitRatio = null;
      suggestion.currentPrice = null;
      suggestion.quantity = 0;
    } else {
      suggestion.recipeId = (newStockitem.group == 'Recipes') ? newStockitem.id : null;
      suggestion.stockItemId = (newStockitem.group == 'Recipes') ? null : newStockitem.id;
      suggestion.unitId = newStockitem.unitId;
      suggestion.unitName = newStockitem.unitName;
      suggestion.unitRatio = newStockitem.unitRatio;
      suggestion.currentPrice = newStockitem.currentPrice;
      suggestion.quantity = 1 * suggestion.unitRatio;
    }
  };

  $scope.unitSet = function(suggestion, newUnit) {
    suggestion.quantity = (suggestion.quantity / suggestion.unitRatio) * newUnit.ratio;
    suggestion.unitRatio = newUnit.ratio;
  };
}]);
